<template>
  <div class="container-fluid">
    <b-table ref="table" :fields="room_air_vol_fields" :items="rooms" :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc" class="table table-borderless table-striped mb-4" sort-icon-right
             thead-class="small border-bottom">
      <template #head(nl_ab_extended)="data">
        <div class="text-center" v-html="data.label"></div>
      </template>
      <template #cell(description)="row">
        <div v-if="configuration.norms_id==1">
          {{ __(row.item.getRoomtype().label) }} {{ row.item.description }}
        </div>
        <div v-else>
          {{ __(row.item.getRoomtypeAt().label) }} {{ row.item.description }}
        </div>
      </template>
      <template #cell(storey)="row"> {{ room_floor_options[row.item.storey].text }} {{ row.item.level }}</template>
      <template #cell(air_type)="row">
        {{ air_type_options[row.item.airType - 1].text }}
      </template>
      <template #cell(window)="row">
        <div v-if="row.item.window == 1">{{ __("lang.kwl.airvolume_calc.yes") }}</div>
        <div v-else>{{ __("lang.kwl.airvolume_calc.no") }}</div>
      </template>
      <template #cell(space)="row">
        {{ parseFloat(row.item.space).toFixed(2) }}
      </template>
      <template #cell(f_zu)="row">
        <div v-if="row.item.airType == 2">{{ row.item.airvolume.fZu }}</div>
        <div v-else>-</div>
      </template>
      <template #cell(nl_zu)="row">
        <div v-if="row.item.airType != 2">-</div>
        <div v-else>{{ row.item.airvolume.airvolume }}</div>
      </template>
      <template #cell(nl_zu_extended)="row">
        <div v-if="row.item.airType == 2 || row.item.ventilationMeasure == 2 || row.item.ventilationMeasure == 6">
          {{ parseFloat(row.item.airvolume.ald).toFixed(1) }} /
          {{ parseFloat(row.item.airvolume.infiltrationAir).toFixed(1) }} /
          {{ parseFloat(row.item.airvolume.airvolume).toFixed(1) }}
        </div>
        <div v-else>-</div>
      </template>
      <template #cell(nl_ab)="row">
        <div v-if="!row.item.airvolume.nlAb || row.item.airvolume.nlAb == 0">-</div>
        <div v-else>{{ row.item.airvolume.nlAb }}</div>
      </template>
      <template #cell(nl_ab_extended)="row">
        <div v-if="row.item.airvolume.airvolume == 0 || row.item.airType != 1" class="text-center">-</div>
        <div v-else-if="row.item.ventilationMeasure == 4 || row.item.ventilationMeasure == 5">
          {{ row.item.airvolume.airvolume }}
        </div>
        <div
          v-else-if="row.item.airvolume.operationmode == 2"
          class="col text-center">
          0 / {{ row.item.airvolume.airvolume }}
        </div>
        <div
          v-else-if="row.item.airvolume.operationmode == 5"
          class="col text-center">
          {{ row.item.airvolume.fl }} / {{ row.item.airvolume.airvolume }}
        </div>
        <div v-else>-</div>
      </template>
      <template #cell(ventilation_measure)="row">

        <div v-if="configuration.norms_id==1">
          {{ __(row.item.getRoomltm().label) }}
        </div>
        <div v-else>
          {{ __(row.item.getRoomltmAt().label) }}
        </div>
      </template>
      <!--      <template #cell(operationmode)="row">
              <div v-if="row.item.airType == 1 && (row.item.ventilationMeasure == 1 || row.item.ventilationMeasure == 6)">
                {{ getOperationMode(row.item.airvolume.operationmode) }}
              </div>
              <div v-else>-</div>
            </template>-->
      <template #custom-foot>
        <tr>
          <td class="border-gray-60 border-bottom border-top" colspan="4"></td>
          <td class="text-right border-gray-60 border-bottom border-top font-weight-normal text-right">
            {{ +parseFloat(roomTotalSpace).toFixed(2) }}
          </td>
          <td v-if="unit.ventilationMeasure == 1 || unit.ventilationMeasure == 7"
              class="text-right border-gray-60 border-bottom border-top font-weight-normal">
            {{ unit.airvolume.ald }} / {{ unit.airvolume.il }} /
            {{ Math.round((unit.airvolume.ald + unit.airvolume.il) * 10) / 10 }}
          </td>
          <td v-if="unit.ventilationMeasure == 2"
              class="text-right border-gray-60 border-bottom border-top font-weight-normal">
            {{ unit.airvolume.ald }} / {{ unit.airvolume.infiltrationAir }} /
            {{ Math.round((unit.airvolume.ald + unit.airvolume.infiltrationAir) * 10) / 10 }}
          </td>
          <td v-if="unit.ventilationMeasure == 1 || unit.ventilationMeasure == 7"
              class="text-right border-gray-60 border-bottom border-top font-weight-normal text-center">
            {{ unit.airvolume.totalDurationAir }} /
            {{ unit.airvolume.totalNeedAir }}
          </td>
          <td
            v-if="unit.ventilationMeasure != 2 && unit.airvolume.manually != 1 && unit.ventilationMeasure != 6 && unit.ventilationMeasure != 5"
            class="text-right border-gray-60 border-bottom border-top"
            colspan="1"></td>
          <td v-if="unit.ventilationMeasure != 1 && unit.ventilationMeasure != 7 && unit.ventilationMeasure != 2"
              class="text-right border-gray-60 border-bottom border-top font-weight-normal text-right">
            {{ unit.airvolume.totalSupplyAir }}
          </td>
          <td
            v-if="unit.ventilationMeasure != 1 && unit.ventilationMeasure != 7 && unit.ventilationMeasure != 5 && unit.ventilationMeasure != 6"
            class="border-gray-60 border-bottom border-top font-weight-normal text-right">
            {{ unit.airvolume.totalExhaustAir }}
          </td>
          <td v-if="unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6"
              class="text-right border-gray-60 border-bottom border-top font-weight-normal text-center">
            0 / {{ unit.airvolume.totalExhaustAir }}
          </td>
          <td class="border-gray-60 border-bottom border-top" colspan="3"></td>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import {setLabels, getLangKeyByValue} from "@services/helpers/langHandler";
import Unit from "@models/building/Unit";
import Operationmode from "@models/helpers/Operationmode";
import RoomtypesHasOperationmodesHasAirvolume from "@models/helpers/RoomtypesHasOperationmodesHasAirvolume";
import Configuration from "@models/project/Configuration";

export default {
  props: ["index", "id"],
  data() {
    return {
      sortBy: "name",
      sortDesc: false,
    };
  },
  methods: {
    setLabels: setLabels,
    getLangKeyByValue: getLangKeyByValue,

    deleteTableHeaders: function (tableHeaders, itemList) {
      itemList.forEach(function (item) {
        var index = -1;
        index = tableHeaders.findIndex((field) => field.key == item);
        if (index > -1) {
          tableHeaders.splice(index, 1);
        }
      });
      return tableHeaders;
    },
    getOperationMode(value) {
      const operationMode = Operationmode.find(value);
      if (operationMode) {
        return operationMode.label;
      }
      return "-";
    },
    getOperationModeAirvolume(value) {
      const operationMode = RoomtypesHasOperationmodesHasAirvolume.find(value);
      if (operationMode) {
        return operationMode.duration_airvolume + " / " + operationMode.need_airvolume;
      }
      return "-";
    },
  },
  computed: {
    unit() {
      return Unit.query().where("id", this.id).with(["airvolume", "rooms.airvolume"]).first();
    },
    rooms() {
      return this.unit.rooms;
    },

    roomTotalSpace() {
      var space = 0;
      this.rooms.forEach(function (room) {
        if (room.space != null) {
          space = space + parseFloat(room.space);
        }
      });
      return space;
    },
    combiExhaustAir() {
      var duration = 0;
      var need = 0;
      var airvolume = 0;
      duration = this.unit.airvolume.totalDurationAir;
      need = this.unit.airvolume.totalNeedAir;
      this.unit.rooms.forEach(function (room, index) {
        if (!room.airvolume) return;
        if (room.ventilationMeasure == 4 || (room.ventilationMeasure == 5 && room.airType == 1)) {
          if (duration == 0 && need == 0) {
            airvolume += +parseFloat(room.airvolume.airvolume).toFixed(1);
            return;
          }
          duration += +parseFloat(room.airvolume.airvolume).toFixed(1);
          need += +parseFloat(room.airvolume.airvolume).toFixed(1);
        }
      });

      if (airvolume != 0) return airvolume;
      return duration + " / " + need;
    },
    room_air_vol_fields: {
      get() {
        var inputFields = JSON.parse(JSON.stringify(this.$store.state.inputs.room_air_vol_fields));
        if (this.unit.ventilationMeasure == 1 || this.unit.ventilationMeasure == 7) {
          inputFields = this.deleteTableHeaders(inputFields, ["f_zu", "nl_zu", "nl_ab", "operationmode"]);
        }
        if (this.unit.ventilationMeasure == 2) {
          inputFields = this.deleteTableHeaders(inputFields, ["f_zu", "nl_zu", "nl_ab_extended", "operationmode"]);
        }
        if (this.unit.ventilationMeasure == 3 || this.unit.ventilationMeasure == 4) {
          inputFields = this.deleteTableHeaders(inputFields, ["nl_zu_extended", "nl_ab_extended", "operationmode"]);
        }
        if (this.unit.ventilationMeasure == 5 || this.unit.ventilationMeasure == 6) {
          if (this.unit.rooms.some((e) => e.ventilationMeasure == 6)) {
            inputFields = this.deleteTableHeaders(inputFields, ["nl_zu_extended", "nl_ab", "f_zu", "operationmode"]);
          } else {
            inputFields = this.deleteTableHeaders(inputFields, ["nl_zu_extended", "nl_ab_extended", "f_zu", "operationmode"]);
          }
        }
        if (this.unit.airvolume.manually == 1) {
          inputFields = this.deleteTableHeaders(inputFields, ["f_zu"]);
        }

        return this.setLabels(inputFields);
      },
    },

    room_floor_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.floors);
      },
    },

    air_type_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.air_types);
      },
    },
    configuration() {
      return Configuration.query().with(['project']).first()
    },

  },
};
</script>
